import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import {withApollo} from 'react-apollo';
import {logout} from 'services/auth/actions';
import {Spinner} from 'components/Spinner';
import Navbar from 'components/NavbarUnauthenticated';


const LOGIN_URL = '/login';
const LOGIN_URL_WITH_REDIRECT = '/login?redirect=';

class LogoutPage extends React.Component {
    static propTypes = {
        logout: PropTypes.func,
        location: PropTypes.shape({
            search: PropTypes.string
        }),
        history: PropTypes.shape({
            push: PropTypes.func
        }),
        client: PropTypes.shape({
            resetStore: PropTypes.func,
            cache: PropTypes.shape({
                reset: PropTypes.func
            })
        })
    };

    componentDidMount() {
        this.resetStoreAndRedirect();
    }

    componentDidUpdate() {
        this.resetStoreAndRedirect();
    }

    resetStoreAndRedirect = () => {
        // Issue with resetStore.
        // https://github.com/apollographql/apollo-client/issues/2919

        /*
        this.props.logout();
        this.props.client.resetStore().then(() => {
            this.props.history.push(this.getLoginUrl());
        });
        */

        this.props.client.cache.reset().then(() => {
            this.props.logout();
            this.props.history.push(this.getLoginUrl());
        });
    };

    getLoginUrl = () => {
        const params = queryString.parse(this.props.location.search);
        if (params.redirect) {
            return this.getLoginUrlWithRedirect(params.redirect);
        }

        return LOGIN_URL;
    };

    getLoginUrlWithRedirect = (redirectUrl) => {
        return `${LOGIN_URL_WITH_REDIRECT}${redirectUrl}`;
    };

    render() {
        return (
            <section className="hero is-fullheight alva-bg">
                <Navbar/>

                <div className="hero-body">
                    <div className="container">
                        <div style={{margin: '0 auto', maxWidth: '400px', textAlign: 'center'}}>
                            <div>
                                <FormattedMessage {...messages.loggingOut}/>
                                <Spinner/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapDispatchToProps = {logout};

export default withApollo(withRouter(connect(null, mapDispatchToProps)(LogoutPage)));
